import { usageId } from "../../constants/usageid.js";
import { AuthenticationSchemaIds, AuthenticationTags } from "../../schemas/authentication.const.js";
export const dictionary = {
    schema: {
        // [AuthenticationSchemaIds_deprecated.ACCESS_TOKEN]: {
        //   title: 'Authorization Bearer Token header',
        //   description: 'The Authorization Bearer Token header to use in API calls.',
        // },
        // [AuthenticationSchemaIds_deprecated.AUTHENTICATION]: {
        //   title: 'Human agent credentials',
        //   description: 'The credentials used for authentication.',
        // },
        // [AuthenticationSchemaIds_deprecated.UPDATE_SECRET]: {
        //   title: "Update Human agent's password",
        //   description: 'The new password and the old password that will be replaced.',
        // },
        // [AuthenticationSchemaIds_deprecated.RESET_SECRET]: {
        //   title: "Reset Human agent's password",
        //   description: 'The e-mail where to send the new password to.',
        // },
        // [AuthenticationSchemaIds_deprecated.RESET_VALIDATION]: {
        //   title: "Restart Human agent's e-mail validation",
        //   description: 'The e-mail where to send the new validation request to.',
        // },
        // [AuthenticationSchemaIds_deprecated.UPDATE_EMAIL]: {
        //   title: "Update human agent's e-mail",
        //   description: 'The new e-mail requested  by the human agent.',
        // },
        [usageId(AuthenticationSchemaIds.AUTHENTICATION, AuthenticationTags.DEFAULT)]: {
            title: 'Sign-in',
            description: 'The credentials used for authentication.',
            abbr: 'Sign-in',
            cti: 'Please specify your credentials.',
        },
        [usageId(AuthenticationSchemaIds.EMAIL, AuthenticationTags.UPDATE_EMAIL)]: {
            title: "Update your e-mail",
            description: 'The e-mail will replace your current e-mail.',
            abbr: 'Update e-mail',
            cti: 'Please specify your new replacement e-mail.',
        },
        [usageId(AuthenticationSchemaIds.UPDATE_SECRET, AuthenticationTags.DEFAULT)]: {
            title: "Update your password",
            description: 'The new password and the old password that will be replaced.',
            abbr: 'Update password',
            cti: 'Please specify your old and your new replacement password.',
        },
        [usageId(AuthenticationSchemaIds.EMAIL, AuthenticationTags.RESET_SECRET)]: {
            title: "Forgot password",
            description: 'A new password will be sent to given e-mail address.',
            abbr: 'Reset password',
            cti: 'Please specify your e-mail.',
        },
        [usageId(AuthenticationSchemaIds.EMAIL, AuthenticationTags.RESET_VALIDATION)]: {
            title: "Restart e-mail validation",
            description: 'A new validation e-mail will be sent to given e-mail address.',
            abbr: 'Revalidate e-mail',
            cti: 'Please specify your e-mail.',
        },
    },
};
